import { render } from "./KassenprojektAuswahl.vue?vue&type=template&id=f1c7045c&scoped=true"
import script from "./KassenprojektAuswahl.vue?vue&type=script&lang=js"
export * from "./KassenprojektAuswahl.vue?vue&type=script&lang=js"

import "./KassenprojektAuswahl.vue?vue&type=style&index=0&id=f1c7045c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c7045c"]])

export default __exports__